import { useEffect, useState } from "react";
import Modal from "react-modal";

import { CloseIconWraper } from "../Modal/modal.styled";
import { ModalProps } from "./modal.props";
import { ModalBody, ModalFooter, ModalHeader } from "./modal.styled";

const AGModalComfirmModal = ({
    visible,
    toggleModal,
    footer,
    title,
    children,
    setHeight,
    setWidth,
    bodyStyle,
    zIndex,
    ...props
}: ModalProps) => {
    const handleClose = () => {
        toggleModal();
    };
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const customStyles = screenWidth >= 768 ? {
        content: {
            margin: "auto",
            borderRadius: 5,
            padding: "0 0",
            width: setWidth ? setWidth : 700,
            fontFamily:
                "Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
            height: setHeight ? setHeight : "",
        },
        overlay: {
            zIndex: zIndex ?? 1000000
        }

    } : {
        content: {
            margin: "auto 0",
            borderRadius: 0,
            padding: "0 0",
            width: "100%",
            left: "0%",
            top: "40px",
            fontFamily: "Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
            height: "200px"
        },
        overlay: {
            zIndex: zIndex ?? 1000000
        }
    };
    return (
        <Modal
            isOpen={visible}
            style={customStyles}
            closeTimeoutMS={100}
        >
            <ModalHeader>
                <div className="title text-[#58585B]">
                    {title}
                </div>
                <CloseIconWraper onClick={handleClose}><CloseIcon /></CloseIconWraper>
            </ModalHeader>
            <ModalBody style={bodyStyle} className="custom-scroll">
                {children}
            </ModalBody>
            <ModalFooter>
                {footer}
            </ModalFooter>
        </Modal >
    );
};

const CloseIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
        <path d="M13.4998 0.0332031C6.14714 0.0332031 0.166016 6.01432 0.166016 13.367C0.166016 20.7196 6.14714 26.7007 13.4998 26.7007C20.8524 26.7007 26.8335 20.7196 26.8335 13.367C26.8335 6.01432 20.8524 0.0332031 13.4998 0.0332031ZM18.9273 17.4831L17.6148 18.7956L13.4999 14.6795L9.38374 18.7944L8.07248 17.4818L12.1874 13.367L8.07248 9.2508L9.38374 7.93829L13.4999 12.0545L17.6161 7.93829L18.9286 9.2508L14.8124 13.367L18.9273 17.4831Z" fill="#58585B" />
    </svg>
}

export default AGModalComfirmModal;